import { LoaderCircleIcon } from 'lucide-react';

import { Header, HeaderIcon } from '@/components/header';
import { Page } from '@/components/layout';

export function NoContext() {
  return (
    <Page>
      <Header>
        <HeaderIcon>
          <LoaderCircleIcon className="animate-spin" />
        </HeaderIcon>
      </Header>
    </Page>
  );
}
